import { render } from "./AppNavbar.vue?vue&type=template&id=87edc03e&scoped=true"
const script = {}

import "./AppNavbar.vue?vue&type=style&index=0&id=87edc03e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87edc03e"]])

export default __exports__